import gql from "graphql-tag"

export default gql`
  fragment MediaRevisionFragment on MediaRevision {
    id
    status
    sourceMetadata
    comparison
    error
    retentionUntil
    publishedAt
    creationDate
    MasterFile {
      id
      name
      size
      remoteStatus
    }
    Version {
      id
      role
      codec
      width
      height
      isHdr
      audioLanguages
      priority
      File {
        id
        name
        size
        remoteStatus
      }
    }
  }
`
